import React from 'react';
import Heading from '../../elements/typography/heading';
import Paragraph from '../../elements/typography/paragraph';

import { CarouselTextContainer, CarouselTextElement } from './phone-carousel-styles';
import { PhoneCarouselPhoneIndex } from './PhoneCarousel.landing';

interface PhoneCarouselTextViewProps {
  indexedPhonesItems: PhoneCarouselPhoneIndex[];
  indexOverride: number;
}

const PhoneCarouselTextView = ({ indexedPhonesItems, indexOverride }: PhoneCarouselTextViewProps): JSX.Element =>  {
  return (
    <CarouselTextContainer>
      {
        indexedPhonesItems.map((phoneItem, index) => {
          return (
            <CarouselTextElement key={index} visible={indexOverride !== null ? indexOverride === phoneItem.phoneIndex : phoneItem.isCenter} >
              <Heading fontFamily="Lato" text={phoneItem.title} size="1.5em" weight="normal" align="center" />
              <Paragraph text={phoneItem.description} size="1.35em" align="center" sizeSm="1.15em" weight="light"/>
            </CarouselTextElement>
          )
        })
      }
    </CarouselTextContainer>
  )
}

export default PhoneCarouselTextView;
